import styled from 'styled-components';


export const CardCarInformation = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 40%;
    height: 19%;
    max-height: 122px;
    background: #F7F7F7;
    border-radius: 16px;
    margin: 0 0 0 24px;
    padding: 12px 24px;
    gap: 8px;

    .row {
        display: flex;
        justify-content: space-between;
    }
`;

export const RowPlateDetran = styled.div`
   display:flex;
   justify-content: space-between;
`;

export const DefaultDivCard = styled.div`
      display:flex;
      line-height: 24px;
`;

export const DefaultTextCard = styled.span<{color: string,weight: number}>`
    font-size: 16px;
    font-weight: ${props => props.weight};
    color: ${props => props.color};
`;

export const SpanPlateDetran = styled.span`
    color: #F58220;
    font-weight: 600;
    font-size: 16px;
    display: inline-block
`;


